import React, { useState, useContext, useEffect } from "react";
import { Modal } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import { UserContext } from "../../App";
import pointLogo from "./Images/point_logo.png";
import DigitalSignaturePopup from "./DigitalSignature";

const LetterOfAuthenticationPopup = ({
  open,
  onClose,
  lead,
}) => {
  const user = useContext(UserContext);

  const [formData, setFormData] = useState({
    name: lead?.name || "",
    address: lead?.fiberHouse?.address || "",
    city: lead?.fiberHouse?.city || "",
    state: lead?.fiberHouse?.state || "",
    zip_code: lead?.fiberHouse?.zip || "",
    cuuentServiceProvider: lead?.currentServiceProvider || "",
    account_number: lead?.accountNumber || "",
    password_pin: lead?.passwordPin || "",
    phone: lead?.phone || "",
    signature: "",
  });

  const [isSignaturePopupOpen, setIsSignaturePopupOpen] = useState(false);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      company: lead?.fiberCompanyId
        ? lead?.fiberCompanyId
        : user?.fiberCompanyId,
    }));
  }, [lead, user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      phone: value,
    }));
  };

  const handleSignatureSave = (signature) => {
    setFormData((prevData) => ({
      ...prevData,
      signature,
    }));
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div
          className="custom_modal"
          style={{ maxHeight: "90vh", paddingTop: "20px" }}
        >
          <img src={pointLogo} alt="Authorized Point Broadband" />

          <div className="am_pm flex items-center justify-center">
            <p className="font-bold text-lg">Letter of Authorization</p>
          </div>
          <div className="inputs">
            <input
              placeholder="Current Name on Bill*"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              placeholder="Physical Address*"
              name="address"
              value={formData.address}
              onChange={handleChange}
              required
            />

            <input
              placeholder="City*"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />

            <input
              placeholder="State*"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
            />

            <input
              placeholder="Zip Code*"
              name="zip_code"
              value={formData.zip_code}
              onChange={handleChange}
              required
            />

            <input
              name="cuuentServiceProvider"
              value={formData.cuuentServiceProvider}
              placeholder="Current Service Provider*"
              onChange={handleChange}
              required
            />

            <input
              placeholder="Account Number*"
              name="account_number"
              value={formData.account_number}
              onChange={handleChange}
              required
            />
            <input
              placeholder="Password/Pin*"
              name="password_pin"
              value={formData.password_pin}
              onChange={handleChange}
              required
            />

            <PhoneInput
              placeholder="Phone Number*"
              country={"us"}
              containerStyle={{ width: "100%", borderRadius: "10px" }}
              inputClass="custom_input"
              value={formData.phone}
              onChange={handlePhoneChange}
              required
            />

            <button
              onClick={() => {
                setIsSignaturePopupOpen(true);
              }}
            >
              Add Signature
            </button>
          </div>
        </div>
      </Modal>
      <DigitalSignaturePopup
        open={isSignaturePopupOpen}
        onClose={() => {
          setIsSignaturePopupOpen(false);
        }}
        onSave={handleSignatureSave}
        formData={formData}
      />
    </>
  );
};

export default LetterOfAuthenticationPopup;